module.exports = __webpack_public_path__ + "static/laser_lg-d23e31de47f399b6b5ab2760dacc1e2b.png";